"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_router_1 = require("react-router");
const translate_1 = require("components/translate");
const useModal_1 = require("hooks/useModal");
const ReviewOverlay_1 = __importDefault(require("modules/reviews/components/ReviewOverlay"));
const ReviewService_1 = __importDefault(require("modules/reviews/ReviewService"));
const types_1 = require("modules/reviews/types");
const ContentImportReview = ({ t }) => {
    const history = (0, react_router_1.useHistory)();
    const location = (0, react_router_1.useLocation)();
    const { isModalOpen, handleOpen, handleClose } = (0, useModal_1.useModal)();
    (0, react_1.useEffect)(() => {
        const queryParams = new URLSearchParams(location.search);
        if (queryParams.get('review') === types_1.ReviewSubject.ContentImport) {
            handleOpen();
        }
        else {
            handleClose();
        }
    }, [location.search, handleClose, handleOpen]);
    const handleSubmit = (review) => {
        ReviewService_1.default.save(types_1.ReviewSubject.ContentImport, review);
        const queryParams = new URLSearchParams(location.search);
        queryParams.delete('review');
        history.replace({
            search: queryParams.toString()
        });
    };
    if (!isModalOpen) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(ReviewOverlay_1.default, { title: t('reviews.questions.import_content'), onClose: handleClose, onSubmit: handleSubmit }));
};
exports.default = (0, translate_1.translate)()(ContentImportReview);
